import {put, takeEvery} from 'redux-saga/effects';
import {createBrowserHistory} from 'history';
import {
  RESETORIGINALPWD_INIT_ACTION,
  RESETORIGINALPWD_FAIL_ACTION,
  RESETORIGINALPWD_SUCCESS_ACTION,
} from './action';
import {appConfig} from '../../config';
import {toast, Flip} from 'react-toastify';
import {push} from 'connected-react-router';
import 'react-toastify/dist/ReactToastify.css';

function* resetOriginalPwd(value) {
  const id = JSON.parse(localStorage.getItem('userDetails')).id;
  const token = localStorage.getItem('token');
  try {
    const data = {
      password: value.value.newpwd
    };
    // console.log(JSON.stringify(data));
    const res = yield fetch(`${appConfig.ip}/users/${id}/password`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    // console.log(res);

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: RESETORIGINALPWD_SUCCESS_ACTION,
        payload: resJSON,
      });
      // console.log(resJSON);
      yield toast.success(
        'Password reset succesfully. Please login again to continue',
        {
          autoClose: 5000,
          transition: Flip,
        }
      );
      yield put(push('/login'));
    }
  } catch (err) {
    if (err.status === 401 || err.status === 404 || err.status === 400) {
      yield toast.error('Sorry!! Try again with the registered password', {
        autoClose: 3000,
        transition: Flip,
      });
    } else {
      yield toast.error('Sorry!! Password not reset', {
        autoClose: 3000,
        transition: Flip,
      });
    }
    yield put({
      type: RESETORIGINALPWD_FAIL_ACTION,
      payload: err,
    });
  }
}

export function* ResetOldPwdActionWatcher() {
  yield takeEvery(RESETORIGINALPWD_INIT_ACTION, resetOriginalPwd);
}
